import { proStudioUrqlGql as urqlGql } from '@pypestream/api-services';
import {
  ProStudioEvents,
  ProStudioContext,
  SelectedSolution,
  Solution,
} from '../prostudio.xstate.types';
import { checkForErrors } from '../../utils';

export const updateSolutionName = async (
  ctx: ProStudioContext,
  event: ProStudioEvents
): Promise<{
  selectedSolution: SelectedSolution | undefined;
  solutions?: Solution[];
  cb?: (path?: string) => void;
} | void> => {
  if (event.type !== 'updateSolutionName') {
    return;
  }

  const { solutions } = ctx;

  const { solutionId, name } = event;

  const updateSolutionNameResponse = await urqlGql.updateSolutionDisplayName({
    displayName: name,
    solutionId,
  });

  checkForErrors(updateSolutionNameResponse);

  const updatedSolutionNameData =
    updateSolutionNameResponse.data?.admin_?.updateSolution;

  const selectedSolution = solutions?.find(
    (solution) =>
      solution.botSolutionId === updatedSolutionNameData?.botSolutionId
  );

  const updatedSelectedSolution = selectedSolution
    ? {
        ...selectedSolution,
        displayName: updatedSolutionNameData?.displayName,
      }
    : undefined;

  const updatedSolutions = solutions?.map((solution) => {
    if (solution.botSolutionId === updatedSelectedSolution?.botSolutionId) {
      return updatedSelectedSolution;
    }
    return solution;
  });

  return {
    selectedSolution: updatedSelectedSolution,
    solutions: updatedSolutions
      ? updatedSolutions.filter(
          (solution): solution is Solution => solution !== undefined
        )
      : undefined,
  };
};
